"use strict";

import angular from "angular";
import core from "../../core.module";
import api from "../api";
import common from "../common";
import {
    alienNumberInput,
    alienNumberMask,
    countryInput,
    dateInput,
    emailInput,
    formSelectInput,
    formTextInput,
    i94Input,
    i94Mask,
    middleInitialInput,
    middleInitialMask,
    paperworkDateMask,
    phoneInput,
    socialInput,
    stateInput,
    uiUsSocialSecurityMask,
    uiUsZipCodeMask,
    zipCodeInput,
    observeMe,
} from "./paperwork.directives";
import _ from "lodash";
import components from "./components";
import { ENGLISH, SPANISH } from "../../app.constants";
import translationsEN from "./translations/en.json";
import translationsES from "./translations/es.json";
import { StartPaperworkFormService } from "./paperwork.services";

let module = angular
    .module("common.paperwork", [core, api.name, common.name])
    .directive("observeMe", observeMe)
    .directive("uiUsSocialSecurityMask", uiUsSocialSecurityMask)
    .directive("uiUsZipCodeMask", uiUsZipCodeMask)
    .directive("dateInput", dateInput)
    .directive("zipCodeInput", zipCodeInput)
    .directive("socialInput", socialInput)
    .directive("emailInput", emailInput)
    .directive("phoneInput", phoneInput)
    .directive("stateInput", stateInput)
    .directive("formTextInput", formTextInput)
    .directive("formSelectInput", formSelectInput)
    .directive("middleInitialMask", middleInitialMask)
    .directive("middleInitialInput", middleInitialInput)
    .directive("i94Mask", i94Mask)
    .directive("i94Input", i94Input)
    .directive("countryInput", countryInput)
    .directive("alienNumberMask", alienNumberMask)
    .directive("alienNumberInput", alienNumberInput)
    .directive("paperworkDateMask", paperworkDateMask)
    .service("StartPaperworkFormService", StartPaperworkFormService);

_.forEach(components, function (component) {
    module.component(component.name, component);
});
module.config(function ($translateProvider) {
    "ngInject";
    $translateProvider.translations(ENGLISH, translationsEN);
    $translateProvider.translations(SPANISH, translationsES);
});

module.config(function ($translateProvider) {
    "ngInject";

    _.forEach(components, function (component) {
        _.forEach(component.translations, function (table, language) {
            $translateProvider.translations(language, table);
        });
    });
});

export default module;
